export class Globals {
  public static weekDayString: Array<any> = [
    { name: "Mo", clicked: true, fullName: "Monday", number: 1 },
    { name: "Tu", clicked: true, fullName: "Tuesday", number: 2 },
    { name: "We", clicked: true, fullName: "Wednesday", number: 3 },
    { name: "Th", clicked: true, fullName: "Thursday", number: 4 },
    { name: "Fr", clicked: true, fullName: "Friday", number: 5 },
    { name: "Sa", clicked: true, fullName: "Saturday", number: 6 },
    { name: "Su", clicked: true, fullName: "Sunday", number: 7 },
  ];
  public static categories: Array<any> = [
    { name: "Food", clicked: false, class: "cat--blue", key: "food" },
    { name: "Culture", clicked: false, class: "cat--green", key: "culture" },
    {
      name: "Guided tours",
      clicked: false,
      class: "cat--light-blue",
      key: "guided_tours",
    },
    { name: "Leisure", clicked: false, class: "cat--orange", key: "leisure" },
    { name: "Nightlife", clicked: false, class: "cat--red", key: "nightlife" },
  ];
}
